<template>
<!-- ******* This template version is for 1-3 interactive boxes above the video frame -->
  <!-- @mousemove="onMouseMovement"  -->

  <div class="hpHero" id="heroVideoContainer1">
    <ul class="hpHeroCollage reveal" id="homeHeroVideo1" style="--clipVal:10%">
      <li>
          <a :href="itemsData[hoverIndex].url">
            <video id="hpVideoPlayer1" 
                :src="itemsData[hoverIndex].img" 
                playsinline 
                data-src="" 
                poster="" 
                title="" 
                autoplay 
                muted>            
              </video>        
          </a>

          <div class="box1Content px-2xl">
            <!-- <img class="boxLogoImg" :src="itemsData[hoverIndex].img" /> -->
            <img class="boxLogoImg" :src="getSvgImg(itemsData[hoverIndex].title)" />

            <div class="hpHeroSubtitle">{{itemsData[hoverIndex].summary}}</div> 
            <div class="heroPager">
                <span 
                  v-for="(item,index) in itemsData" 
                  @click="switchVideo(index)"
                  :key="'pager_'+index" 
                  :class="[index==hoverIndex ? 'active':'']">
                </span>
            </div>
          </div>

      </li>
    </ul>
    
    
  </div>
</template>

<style>
  .hpHeroCollage .heroPager{
    clear: both;
    padding-top: 20px;
    background: transparent;
    display: inline-flex;
    column-gap: 5px;    
    margin: auto;
  }

    .box1Content
    {      
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
    }

    .hpHeroCollage .box1Content
    {
      transition: all ease 0.6s;
      opacity: 1;
    }
    .hpHeroCollage.mini .box1Content
    {
      opacity: 0;
    }

  .heroPager span{
    height: 5px;
    background-color: #fff;
    width: 40px;
    padding-right: 5px;
    float: left;
    opacity: 0.3;
    cursor: pointer;
  }
  .heroPager span:hover{
      opacity: 0.8;
  }  
  .heroPager span.active
  {
      opacity: 1;
  }

</style>


<script>
import { mapState } from "vuex";
export default {
  props: {
    sectionData:{} 
  },  
  data() {
    return {
        //
        loadedData:[],
        showBoxes:false,
        timerInt:null,
        timerCounter:0,
        hoverIndex:0,
        videoBgSrc:'',
        //CONNECT
        //palma_logo4
        //
        ____itemsData:[],
        _______itemsData:
        [
          {
            "title":"",
            "subtitle":"Tissue-Level Screw-Retained Solution",
            "url":"products/prosthetic-options/screw-retained/connect-system",
            "img":"https://www.mis-implants.com/img/product-logos/CONNECT.svg",
            "video":"https://mis-implants.com/upload/home/global/videos/MIS_CONNECT.mp4",
            "bg":""
          },
          {
            "title":"",
            "subtitle":"Join the MIS Community",
            "url":"https://360.mis-implants.com/",
            "img":"https://www.mis-implants.com/img/product-logos/palma_logo4.svg",
            "video":"https://mis-implants.com/upload/home/global/videos/mis_global_conference_palma.mp4",
            "bg":""
          }
          /*
          {
            "title":"Welcome to MIS Implants",
            "subtitle":"Making it Simple for over 25 years",
            "url":"https://www.mis-implants.com/products/kits-and-tools/xd-drills",
            "img":""
          }*/
        ]        
    };
  },
  mounted() {
    var vm = this;
    this.$nextTick(function() {
      vm.initVideoEvents();
    });
    //this.loadHeroItems();    
  },
  watch: {
  },
  computed: {
    itemsData()
    {
        return this.sectionData.items;
    },
    itemsDataComp()
    {
        return this.loadedData;
    },
    pageData()
    {
      return this.sectionData.items;
    }
  },
  methods: 
  {
    getSvgImg(img)
    {
        if(img.indexOf("@")>-1)
        {
          //in case for example img is "@connect" we need to change to https://...../connect.svg
          var svgFile = img.replace("@","");
          return "https://www.mis-implants.com/img/product-logos/"+svgFile+".svg";
        }else{
          //return the img as is 
          return img;
        }
    },
    initVideoEvents()
    {
      var vm = this;
      var videoElement = document.getElementById('hpVideoPlayer1');
      videoElement.addEventListener('ended',vm.onHpVideoEnded,false);
       console.log("added ended event listener");
    },

    onHpVideoEnded(e)
    {
      console.log("next video");
      let nextIndex = this.hoverIndex+1;
      if(nextIndex>this.itemsData.length-1){
        nextIndex=0;
      }
      console.log("next video nextIndex="+nextIndex);
      this.hoverIndex = nextIndex;
    },

    loadHeroItems()
    {
      var vm = this;
      var apiURL = "content/hp/site_data.json";
      fetch(apiURL, {method: "GET",cache: "no-cache", headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},})
      .then(function(response) { return response.json();})
      .then(function(response){
        vm.loadedData = response;
        //vm.initVideoEvents();
        //alert("items loaded:"+response);
      });
    },                 
    switchVideo(index)
    {
      //fade out // 
      this.hoverIndex = index
      //fade in //
    },
    onMouseMovement()
    {
        var vm = this;
        vm.timerCounter=0;
        vm.showBoxes = true;
    },
    onItemOver(index)
    {
        this.hoverIndex = index;
    }
  }
};
</script>

<style scoped>
    .hpHero
    {
        display: block;
        position: relative;
        height: auto;
        overflow: hidden;
    }
    .hpHero .hpHeroContent
    {
        position: absolute;
        bottom: 0px;
        height: auto;
        width: 100%;
        text-align: center;
        padding: 10vw 10vw 3vw 10vw;        
    }
    .hphGrid
    {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0px;
        gap: 20px;
        flex-wrap: wrap;
        margin: 0px;       
        /* opacity: 1; transition: all ease 0.4s; */
    }
    .hphGrid.active
    {
        /* opacity: 1; */
    }
    .hphItem
    {
        cursor: pointer !important;
        flex: 1;
        height: 12vw;
        background-color: rgba(255, 255, 255, 0.1);        
        /* clip-path: inset(0 50% 0 0); */
        opacity: 0;        
        transition: all ease 1s;
        transition-delay: calc(var(--index) * 0.1s);        
    }
    .hphItem.active
    {
        opacity: 1;
        /* clip-path: inset(0 0 0 0); */
    }
    .hphItem:hover
    {
        background-color: rgba(11, 11, 11, 0.75);
    }
    .hpHero .hpHeroContent img
    {
        width: 40vh;
        height: auto;
    }
    .hpHeroSubtitle
    {
        padding-top:2px;
        text-align: center;
        font-weight: 300 !important;
        font-size: 1.2vw;
        letter-spacing: -0.5px !important;
    }
    .hpHeroInner
    {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000;
    }
    .hpHeroCollage_V1
    {
        width: 80vw;
        height: 60vw;
        margin: auto;        
        background-color: #000;
        padding: 0px;
        list-style: none;        
        clip-path: inset(0%);        
        transition: all ease-in-out 0.5s;
        border-radius: 25px;
        overflow: hidden;
    }    


    .hpHeroCollage
    {
        width: 100vw;
        height: 45vw;
        margin: auto;        
        background-color: #000;
        padding: 0px;
        list-style: none;                
        /* transition: all ease-in-out 0.4s; */
        border-radius: 0px;
        overflow: hidden;
        position: relative;        
        /* clip-path: inset(0%); */
        /* transform: matrix(1, 0, 0, 1, 0, 0); */
        /* clip-path: inset(0% round 0px); */
    }
      .hpHeroCollage.mini
      {
          /* width: 80vw; */
          /* border-radius: 25px; */
          /* clip-path: inset(5% 5% 5% 5%); */
          /* transform: matrix(1, 0, 0, 1, -120, -50); */
              /* clip-path: inset(6.25% round 40px); */
              /* clip-path: inset(6.25% round 40px); */

      }



    .hpHeroCollage li:nth-child(1)
    {
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: 3;
    }
    .hpHeroCollage li
    {
      /* position: relative; */
      overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    /* height: 50vw; */      
    height: 45vw;
      
    }
    .hpHeroCollage li video
    {
      opacity: 1;
    }
    .hpHeroCollage li img
    {      
      opacity: 0.4;
    }

    /* main box */
    .box1Content
    {
        position: absolute;
        bottom: 3vw;
    }
    .boxLogoImg
    {
      opacity: 1 !important;
      width: 17vw;
      height: auto;
    }

    .hpHeroCollage li .boxContent
    {      
      position: absolute;
      bottom: 0px;
      color:#fff;
      padding: 3vw;
      opacity: 0;
      transition: all ease 0.4s;
    }
    .hpHeroCollage li:hover .boxContent
    {      
      opacity: 1;
    }

    .hpHeroCollage li .bgImg
    {
        opacity: 0.3;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;   
        transition: all ease 0.5s;     
    }    
    .hpHeroCollage li:hover .bgImg
    {
        opacity: 0.6;
        transform: scale(1.05);
    }

    .hpHeroCollage li .boxContent span:nth-child(1)
    {
        display: block;
        color: #fff;
        font-size: 24px;
        line-height: 24px;
        letter-spacing: -1px !important;
        font-weight: 300 !important;
    }
    .hpHeroCollage li .boxContent span:nth-child(2)
    {
        display: block;
        color: #e1e1e1;
        font-size: 14px;
        padding-top: 8px;
        font-weight: 400 !important;
    }

    .hpHeroCollage li:nth-child(2)
    {
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 1;
        grid-row-end: 2;
        background-color: #000;
    }
    .hpHeroCollage li:nth-child(3)
    {
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 2;
        grid-row-end: 3;
        background-color: #000;
    }
    .hpHeroCollage .bgImg
    {
        opacity: 0.3;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;        
    }
    .hpHeroCollage video
    {
        opacity: 1;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;        
    }
    .textLink span
    {
      color: #fff;
      font-weight: 500 !important;
      border-radius: 30px;
      padding: 10px 20px;
      border: solid 2px #fff;
    }
    .btnWrap
    {
      clear: both;
      padding-top: 2vw;
    }

    .hphInner
    {
      position: relative;
      padding: 2.5vw;
      height: 100%;
      cursor: pointer !important;
    }
    .hphItem:hover .hph-arrow
    {
      opacity: 0.6;
      transform: translateX(-50%);
    }
    .hph-arrow
    {
      position: absolute;
      bottom: 2.5vw;
      right: 1.25vw;
      color: #fff;
      font-size: 1.3vw;
      transform: translateX(-100%);
      opacity: 0;
      transition: all ease 0.4s;
    }
    .hph-elements
    {
      position: absolute;
      bottom: 2.5vw;
    }
    .hph-img
    {
        clear: both;
        text-align: left;
        padding-bottom: 1px;
    }
    .hph-img img
    {
        height: 2.6vw !important;
        width: auto !important;
    }
    .hph-title
    {
        color: #fff;
        font-weight: 300 !important;
        text-align: left;
        font-size: clamp(2vw,2.4vw,4.5rem);
        line-height: clamp(2vw,2.2vw,4.5rem);
        padding-bottom: 10px;
        letter-spacing: -1px !important;
    }
    .hph-subtitle
    {
        text-align: left;
        color: #fff;
        font-weight: 300 !important;
    }

    .iscroll
    {
      width: 20px;
      height: 36px;
      position: absolute;
      left: 50%;
      z-index: 10;
      transform: translate(-50%,0%);
      bottom: 3vw;
    }    

  /* ----------- mobile ----------- */
  @media screen and (max-width: 815px) {
    .hpHero
    {
      padding-bottom: 0px !important;
    }
    .hpHeroCollage
    {
      width: 100vw;
      height: 65vh;
      border-radius: 0px;
    }
    .hpHeroCollage li{height: 65vh;}    
    .hpHeroCollage video{
        height: 65vh;
        object-fit: cover;
    }    
    .boxLogoImg
    {
      height: 8vw;
      width: auto;
    }
    .box1Content
    {
      width: 100%;
          bottom: 30px;

    }
    .hpHeroCollage .heroPager {
      padding-top: 20px;
    }
    .hpHeroSubtitle
    {
        font-size: 16px;
    }
  }    


    /* Portrait */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) 
      {
          ._heroIn
          {
            padding:0px !important;
          }
          .hpHeroCollage {
              height: 60vw;
              clip-path: inset(0% 0% 0% 0%) !important;
          }          
          .hpHeroCollage li{
              height: 60vw;
          }          
          .hpHeroCollage.mini .box1Content {
              opacity: 1;
          }
      }    

    /* iPad pro Landscape */
    /* Declare the same value for min- and max-width to avoid colliding with desktops */
    /* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (min-height: 1024px) 
      and (orientation: landscape) 
      and (-webkit-min-device-pixel-ratio: 1.5) 
      {
          .hpHeroCollage {
              height: 60vw;
          }          
          .hpHeroCollage li{
              height: 60vw;
          }             
      }



    /* large screens */
    @media only screen and (min-width:2400px)
    {
        .hpHeroCollage{height: 60vw;}
        .hpHeroCollage li{height: 60vw;}
    }

</style>


<style lang="stylus">
  .icon_scroll
    position: absolute
    left: 0%
  .icon_scroll:before
    position: absolute
    left: 50%
  .icon_scroll
    width: 20px
    height: 36px
    //margin-left: -20px
    //top: 50%
    //margin-top: -35px
    box-shadow: inset 0 0 0 1px #fff
    border-radius: 25px
  .icon_scroll:before
    content: ''
    width: 4px
    height: 8px
    background: #fff
    margin-left: -2px
    top: 8px
    border-radius: 4px
    animation-duration: 2s
    animation-iteration-count: infinite
    animation-name: icon_scroll

  @keyframes icon_scroll
    0%
      opacity: 1
    100%
      opacity: 0
      transform: translateY(8px)
</style>
